var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHederaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00781 8.93896H14.1661V10.9751H6.00781V8.93896Z",
    fill: "#0B213E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.4772 0 0 4.4772 0 10C0 15.5228 4.4772 20 10 20C15.5228 20 20 15.5228 20 10C20 4.4772 15.5228 0 10 0ZM15.9328 16.3889H14.0795V12.4483H5.92053V16.3889H4.0672V3.61113H5.92053V7.45667H14.0794V3.61113H15.9327V16.3889H15.9328Z",
    fill: "#0B213E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHederaLogo);
export default __webpack_public_path__ + "static/media/HederaLogo.d6a95068d5a6bbe530ff00896c87d1f8.svg";
export { ForwardRef as ReactComponent };